module.exports = __webpack_public_path__ + "static/img/tab4pic.36d0f8ba.png";